<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <!-- <div class="row justify-content-center"> -->
      <div class="row">
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Sales</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>
                  {{ totalSales | currency }}
                </span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-primary">Total Payment</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ totalPayment | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Total Outstanding</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ (totalSales - totalRetur) - totalPayment | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Omzet</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ totalOmzet | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Discount</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ totalDiscount | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Journal</span></h5>
              <h3 class="my-3">
                <span v-if="loadingSales === false">
                  <div class="loadingio-spinner-bars-km984sg9h2">
                    <div class="ldio-m41ff6uvz8">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </span>
                <span v-else>{{ getTotalJournal | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
          <!-- getTotalJournalCost -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h5>Sales</h5>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <div class="form-inline ml-auto">
                    <div class="button-group">
                      <button type="button" class="btn btn-sm btn-soft-primary dropdown-toggle" data-toggle="dropdown" id="dropDownFilter">Action<span class="caret"></span></button>
                      <ul class="dropdown-menu p-2" aria-labelledby="dropDownFilter">
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="setJournal">Set Journal</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="setJournalStockOut">Set Journal Stock Out</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="approveAll">Approve</a></li>
                        <!-- <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="deleteAll">Delete</a></li> -->
                        <!-- <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="deleteAll">Void</a></li> -->
                      </ul>
                      <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addSales">
                          <i class="fa fa-plus" aria-hidden="true"></i> New
                      </button>
                      <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshSales">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                      </button>
                    </div>
                    <div class="button-group">
                      <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-filter" aria-hidden="true"></i>
                          Filter
                          <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu p-2" >
                        <span>Company:</span>
                        <div class="dropdown-divider"></div>
                        <li v-for="c in companyList" :key="c.id">
                          <a href="javascript:void(0)" class="small" tabIndex="-1">
                            <input type="checkbox" :value="c.company_no" v-model="filterCompany"/>&nbsp; {{ c.name }}
                          </a>
                        </li>
                        <span>Status:</span>
                        <div class="dropdown-divider"></div>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterStatus" value="approved"/> Approved</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterStatus" value="outstanding"/> Outstanding</a></li>
                        <span>Other:</span>
                        <div class="dropdown-divider"></div>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterRetur" value="true"/> Retur Sales</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterDiffJournal" value="true"/> Diff Journal {{ filterDiffJournal }}</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterDiffTotalDetail" value="true"/> Diff Total Detail {{ filterDiffTotalDetail }}</a></li>
                      </ul>
                      rows:
                      <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                        <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                      </select>
                      <span class="mr-1">
                        Total rows: <b>{{ filterData.length }}</b>
                      </span>
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshSales"></date-picker>
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                        <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                    </div>
                    <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                    <nav aria-label="Page navigation example" class="pull-right">
                        <ul class="pagination">
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
                  </div>
                  <table class="table table-item mb-0 table-sm table-striped">
                      <thead>
                          <tr>
                              <th>
                                <label class="form-checkbox">
                                  <input type="checkbox" v-model="selectAll" @click="select">
                                  <i class="form-icon"></i>
                                </label>
                              </th>
                              <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)" :class="t.align">
                                  <span v-if="t.name === 'Payment'" class="text-right">
                                  {{ t.name }}
                                  <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </span>

                                  <span v-else>
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                  </span>
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr v-if="filterData.length < 1">
                          <td colspan="21" style="text-align: center;"><i>No Data</i></td>
                        </tr>
                        <tr v-for="u in filterData" :key="u.id">
                          <td>
                            <label class="form-checkbox">
                              <input type="checkbox" :value="u.id" v-model="selected">
                              <i class="form-icon"></i>
                            </label>
                          </td>
                          <td>
                            <span class="badge badge-success" v-if="u.status === 'Open'">{{ u.status }}</span>
                            <span class="badge badge-warning" v-else-if="u.status === 'outstanding'">{{ u.status }}</span>
                            <span class="badge badge-primary" v-else-if="u.status === 'approved'">{{ u.status }}</span>
                            <span class="badge badge-warning" v-else-if="u.status === 'order'">{{ u.status }}</span>
                            <span class="badge badge-danger" v-else>{{ u.status }}</span>
                          </td>
                          <td>
                            <!-- <button type="button" class="btn btn-sm btn-soft-outline-primary" @click="editSales(u.id, 'payment')">Payment</button> -->
                            <!-- <button type="button" class="btn btn-sm btn-soft-outline-primary" @click="editSales(u.id, 'deliver')">Delivery</button> -->
                            <!-- <button v-if="u.return_total > 0 || u.return_total !== null" type="button" class="btn btn-sm btn-success" @click="editSales(u.id, 'retur')">Retur</button> -->
                            <!-- <button v-else type="button" class="btn btn-sm btn-soft-outline-primary" @click="editSales(u.id, 'retur')">Retur</button> -->
                          </td>
                          <td @click="editSales(u.id, 'sales')" style="cursor: pointer"><b>{{ u.sale_no }}</b></td>
                          <td>
                            <ul v-for="(o, index) in u.order_no" :key="index">
                              <li style="color: blue">{{ o.project_name }}</li>
                            </ul>
                          </td>
                          <td>{{ u.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>
                            <span class="badge badge-danger" v-if="u.overdue === 'overdue'">{{ u.overdue }}</span>
                            <span v-else>{{ u.sale_due_date | dateFormat('DD/MM/YYYY') }}</span>
                          </td>
                          <td>{{ u.company }}</td>
                          <td>{{ u.customer_name }}</td>
                          <td>{{ u.salesman }}</td>
                          <td class="text-right">
                            <!-- <span v-if="u.total_payment >= u.total"> -->
                              <!-- <span class="badge badge-success">Lunas</span> -->
                            <!-- </span> -->
                            <span>{{ u.total_payment | currency }}</span>
                          </td>
                          <td class="text-right">{{ u.subtotal | currency }}</td>
                          <td class="text-right">{{ u.discount | currency }}</td>
                          <td class="text-right">{{ u.dpp | currency }}</td>
                          <td class="text-right">{{ u.tax | currency }}</td>
                          <td class="text-right">{{ u.total | currency }}</td>
                          <td class="text-right">{{ u.return_total | currency }}</td>
                          <td class="text-right">
                            <span v-if="u.total_debit_journal !== u.total" class="badge badge-danger">{{ u.total_debit_journal | currency }}</span>
                            <span v-else>{{ u.total_debit_journal | currency }}</span>
                            <!-- <span>({{ u.journal_count }})</span> -->
                          </td>
                          <td>
                            <!-- <span v-if="u.cogs === true"><i class="fa fa-check"></i></span> -->
                            {{ u.journal_count }}
                          </td>
                          <td>{{ u.details_count }}</td>
                          <td>
                            <span v-if="u.details_count !== u.delivery_count" class="badge badge-danger">{{ u.delivery_count }}</span>
                            <span v-else class="badge badge-success">{{ u.delivery_count }}</span>
                          </td>
                          <td>
                            <span v-if="u.total_detail !== u.subtotal" class="badge badge-danger">{{ u.total_detail | currency }}</span>
                            <span v-else>{{ u.total_detail | currency }}</span>
                          </td>
                        </tr>
                      </tbody>
                      <!-- <tfoot>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td class="text-right">
                            <b>{{ getTotalPayment | currency }}</b>
                          </td>
                          <td class="text-right">
                            <b>{{getTotalSubtotal | currency }}</b>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td class="text-right">
                            <b>{{ getTotalSales | currency }}</b>
                          </td>
                          <td class="text-right">
                            <b>{{ getTotalJournal | currency }}</b>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tfoot> -->
                  </table>
                </div>
              </div>
            </div>
        </div>
      </div>
      <!-- <pre>{{ filterCompany }}</pre> -->
      <!-- <pre>{{ dataRaw }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { productUrl, salesUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import DatePicker from 'vue2-datepicker'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'

export default {
  name: 'SalesUnitList',
  components: {
    Loading,
    DatePicker
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    const date1 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    const date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    return {
      filterDiffJournal: false,
      filterDiffTotalDetail: false,
      filterRetur: null,
      filterCompany: ['C0001', 'C0002'],
      loadingSales: true,
      filterStatus: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      checkFilter: [],
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: '#',
        prop: '',
        align: 'text-left'
      }, {
        name: 'Sale No',
        prop: 'sale_no',
        align: 'text-left'
      }, {
        name: 'Order No',
        prop: 'order_no',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'sale_date',
        align: 'text-left'
      }, {
        name: 'Due Date',
        prop: 'sale_due_date'
      }, {
        name: 'Company',
        prop: 'company',
        align: 'text-left'
      }, {
        name: 'Customer',
        prop: 'customer_name',
        align: 'text-left'
      }, {
        name: 'Sales Person',
        prop: 'salesman',
        align: 'text-left'
      }, {
        name: 'Payment',
        prop: 'total_payment',
        align: 'text-right'
      }, {
        name: 'Subtotal',
        prop: 'subtotal',
        align: 'text-right'
      }, {
        name: 'Discount',
        prop: 'discount',
        align: 'text-right'
      }, {
        name: 'DPP',
        prop: 'dpp',
        align: 'text-right'
      }, {
        name: 'Tax',
        prop: 'tax',
        align: 'text-right'
      }, {
        name: 'Total',
        prop: 'total',
        align: 'text-right'
      }, {
        name: 'Retur',
        prop: 'return_total'
      }, {
        name: 'Total Journal',
        prop: 'total_debit_journal',
        align: 'text-right'
      }, {
        name: 'Journal Count',
        prop: 'journal_count',
        align: 'text-left'
      }, {
        name: 'Detail Count',
        prop: 'details_count',
        align: 'text-left'
      }, {
        name: 'Delivery Count',
        prop: 'delivery_count',
        align: 'text-left'
      }, {
        name: 'Total Detail',
        prop: 'total_detail',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshSales()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      saleStatusList: state => state.sales.saleStatusList,
      companyList: state => state.companies.companyList
    }),
    totalDiscount () {
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].discount)
      }
      return sum
    },
    totalRetur () {
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].return_total !== null) {
          sum += parseFloat(array[i].return_total)
        }
      }
      return sum
    },
    totalOmzet () {
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].dpp)
      }
      return sum
    },
    getTotalSubtotal () {
      var sum = 0
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].subtotal)
      }
      return sum
    },
    getTotalJournal () {
      var sum = 0
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_debit_journal)
      }
      return sum
    },
    getTotalJournalCost () {
      var sum = 0
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal_stock_out)
      }
      return sum
    },
    totalPayment: function () {
      var array = this.dataRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_payment)
      }
      return sum
    },
    totalSales () {
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      console.log('totalSales:')
      console.log(array)
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    getTotalPayment: function () {
      var num = 0
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      for (let i = 0; i < array.length; i++) {
        num += parseFloat(array[i].total_payment)
      }
      return num
    },
    getTotalSales: function () {
      var num = 0
      var array = []
      if (this.filterCompany.length > 1) {
        array = this.dataRaw
      } else {
        array = this.dataRaw.filter(d => d.company_no === this.filterCompany[0])
      }
      for (let i = 0; i < array.length; i++) {
        if (array[i].total === null || array[i].total === '') {
          num += 0
        } else {
          num += parseFloat(array[i].total)
        }
      }
      return num
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterStatus.length > 0) {
          for (let i = 0; i < this.filterStatus.length; i++) {
            if (d.status === this.filterStatus[i]) {
              return d
            } else if (this.filterStatus[i] === 'outstanding') {
              if (d.total_payment < d.total) {
                return d
              }
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          for (let i = 0; i < this.filterCompany.length; i++) {
            if (d.company_no === this.filterCompany[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterRetur === true) {
          if (parseFloat(d.return_total) > 0) {
            return d
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterDiffJournal === true) {
          if (parseFloat(d.total_debit_journal) !== parseFloat(d.total)) {
            return d
          }
        } else {
          return d
        }
      }).filter(d => {
        if (this.filterDiffTotalDetail === true) {
          if (parseFloat(d.total_detail) !== parseFloat(d.subtotal)) {
            return d
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async deleteAll () {
      this.$Progress.start()
      // this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      var sales = []
      for (let i = 0; i < array.length; i++) {
        await axios.delete(salesUrl + '/' + array[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
            var arr = response.data.data.details
            for (let z = 0; z < arr.length; z++) {
              var obj = {
                product_no: arr[z].product_no,
                sale_date: arr[z].sale_date,
                company_no: arr[z].company_no
              }
            }
            this.selected = []
            sales.push(obj)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      for (let a = 0; a < sales.length; a++) {
        var dataSync = {
          date: sales[a].sale_date,
          product_no: sales[a].product_no,
          company_no: sales[a].company_no,
          type: 'all'
        }
        await axios.post(productUrl + '/cost/sync', dataSync, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      if (resp.error === false) {
        await this.$Progress.finish()
        this.loader.isLoading = false
        this.selected = []
        await this.$swal('Success', resp.message, 'success')
        await this.refreshSales()
      }
    },
    async approveAll () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var det = []
      var salesData = []
      for (let i = 0; i < array.length; i++) {
        await axios.get(salesUrl + '/' + array[i], { headers: getHeader() })
          .then(response => {
            var sales = response.data.data
            salesData.push(sales)
            // details
            var details = response.data.data.details
            if (details.length > 0) {
              for (let a = 0; a < details.length; a++) {
                var obj = {
                  date: sales.sale_date,
                  product_no: details[a].product_no,
                  company_no: sales.company_no
                }
                det.push(obj)
              }
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      // set cogs
      for (let a = 0; a < det.length; a++) {
        var data = {
          date: det[a].date,
          product_no: det[a].product_no,
          type: 'all',
          company_no: det[a].company_no
        }
        await axios.post(productUrl + '/cost/sync', data, { headers: getHeader() })
          .then(response => {
            console.log('success sync cogs ' + det[a].product_no)
            console.log(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      var resp = {
        error: false,
        message: null,
        data: []
      }
      for (let b = 0; b < salesData.length; b++) {
        await axios.get(salesUrl + '/journal/' + salesData[b].id, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
        await axios.get(salesUrl + '/journal-stock-out/' + salesData[b].id, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
        await axios.put(salesUrl + '/approve/' + salesData[b].id, salesData[b], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
            resp.data.push(response.data.data)
          })
          .catch(error => {
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      if (resp.error === false) {
        await this.$swal('Success', resp.message, 'success')
        await this.$Progress.finish()
        this.loader.isLoading = false
      } else {
        await this.$swal('Error', 'Approve Error', 'error')
        await this.$Progress.finish()
        this.loader.isLoading = false
      }
      await this.refreshSales()
    },
    async setJournal () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        await axios.get(salesUrl + '/journal/' + array[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
        await axios.get(salesUrl + '/journal-stock-out/' + array[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      if (resp.error) {
        this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Error', resp.message, 'error')
      } else {
        this.$Progress.finish()
        this.loader.isLoading = false
        this.selected = []
        this.selectAll = false
        await this.$swal('Success', resp.message, 'success')
      }
    },
    async setJournalStockOut () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selected
      var resp = {
        error: false,
        message: null
      }
      for (let i = 0; i < array.length; i++) {
        await axios.get(salesUrl + '/journal-stock-out/' + array[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            resp.error = false
            resp.message = response.data.message
          })
          .catch(error => {
            console.log(error.response)
            resp.error = true
            resp.message = error.response.data.message
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      if (resp.error) {
        this.$Progress.finish()
        this.loader.isLoading = false
        await this.$swal('Error', resp.message, 'error')
      } else {
        this.$Progress.finish()
        this.loader.isLoading = false
        this.selected = []
        this.selectAll = false
        await this.$swal('Success', resp.message, 'success')
      }
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      // this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editSales (id, status) {
      console.log(salesUrl + '/' + id)
      axios.get(salesUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          if (status === 'payment') {
            this.$emit('editPayment', response.data.data)
          } else if (status === 'sales') {
            this.$emit('editSales', response.data.data)
          } else if (status === 'deliver') {
            this.$emit('editDelivery', response.data.data)
          } else if (status === 'retur') {
            this.$emit('editRetur', response.data.data)
          }
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    addSales () {
      this.$emit('newSales', true)
    },
    refreshSales () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = salesUrl + '?begin=' + begin + '&end=' + end
      console.log(url)
      axios.get(url, { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
